/** @format */

export const config = {
  
  // strapiAPi:  process.env.API_URL
   
 //strapiAPi: "http://localhost:1337"
  strapiAPi: "https://api.sswhite.net",
   // http://143.244.137.145:5000/ http://localhost:1337


   
   };
   

   